module.exports = __webpack_public_path__ + "static/img/4895_phase_function_Paper_PointsHejduk_Prediction.7a52b46.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4895_phase_function_Paper_PointsHejduk_Prediction.png
// module id = a2HX
// module chunks = 0